import { ALGOLIA_ASSESSMENT_ICD_CODES } from "core/consts";
import { Z_INDEX_ASSESSMENT_CONTENT } from "ds_legacy/materials/metrics";
import AlgoliaSelect from "dsl/atoms/AlgoliaSelect";
import { useTranslations } from "translations";

type IcdHit = {
  code: string;
  description: string;
};

export const renderIcdHit = ({ code, description }: IcdHit, index: number) => {
  return {
    description,
    id: index,
    label: `(${code}) ${description}`,
    value: code,
  };
};

export default function IcdCodesSelect({
  hideError,
  isAdditional,
  isRequired,
}: {
  hideError?: boolean;
  isAdditional?: boolean;
  isRequired?: boolean;
}) {
  const translations = useTranslations();

  return (
    <AlgoliaSelect
      algoliaAnalyticsName={ALGOLIA_ASSESSMENT_ICD_CODES}
      elementName={isAdditional ? "additional_icd_codes" : "icd_code"}
      enableAutoHighlight={!isAdditional}
      hideError={hideError}
      indexName="icd_codes"
      isConnected
      isMultiple={isAdditional}
      isRequired={isRequired}
      label={
        isAdditional
          ? translations.patient.medicalDiagnosis.icdCodesAdditional
          : translations.patient.medicalDiagnosis.icdCodesMain
      }
      maxOptions={5}
      placeholder={
        isAdditional
          ? translations.general.selectDefaultPlaceholder
          : translations.general.selectDefaultPlaceholderShort
      }
      renderHits={renderIcdHit}
      shouldCloseMenuOnSelect={!isAdditional}
      shouldFilterSelectedOptions={isAdditional}
      shouldSearchOnInitialRender
      shouldTruncateMenuItems
      withPortal
      withShortValue={isAdditional}
      zIndex={Z_INDEX_ASSESSMENT_CONTENT}
    />
  );
}
